$(document).ready(function() {
    $(".faq-header").click(function() {
        // Get the unique ID from the clicked header's data attribute
        var faqId = $(this).data("faq-id");
        
        // Toggle the related content and rotate the SVG icon
        $("[data-faq-content-id='" + faqId + "']").slideToggle("slow");
        $(this).find(".faq-icon svg").toggleClass("faqrotate-180");
    });
});
